import axios from "axios"

const UseApiService = {
    get: ({ url, params, headers, query,headerToken }) => {
        const finalParams = query ? { ...params, ...query } : params;
        return axios.get(url, {
            params: finalParams,
            headers,
            headerToken
        });
    },

    post: ({ url, data, params, headers,headerToken }) => {
        return axios.post(url, data, {
            params,
            headers,
            headerToken
        });
    },

    put: ({ url, data, params, headers,headerToken }) => {
        return axios.put(url, data, {
            params,
            headers,
            headerToken
        });
    },

    patch: ({ url, data, params, headers,headerToken }) => {
        return axios.patch(url, data, {
            params,
            headers,
            headerToken
        });
    },

    delete: ({ url, params, headers,headerToken }) => {
        return axios.delete(url, {
            params,
            headers,
            headerToken
        });
    },
};

export default UseApiService;

 
